import styled from "styled-components";
import { theme } from "../../theme";

export const StyledHeader = styled.nav<{ open?: boolean }>`
  background-color: ${theme.backgroundColor.primaryBlack};
  color: ${theme.textColor.primaryWhite};
  font-size: 14px;
  font-weight: 500;
  padding: 8px 0;
  position: fixed;
  width: 100%;
  z-index: 10;
  top: 0;

  div.header-sub-cont {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 24px;
    ul:first-child {
      padding: 0 !important;
    }
  }
  ul {
    display: flex;
    justify-content: flex-start;
    text-decoration: none;
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    line-height: 24px;
    margin: 0;
    li {
      cursor: pointer;
    }
    li.user-name {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      position: relative;
      color: ${theme.textColor.secondaryGray};

      span {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        margin-left: 8px;
        margin-top: 2px;
        border-top: 5px solid ${theme.textColor.secondaryGray};
      }
      &:hover {
        color: ${theme.textColor.primaryWhite};
        span {
          border-top: 5px solid ${theme.textColor.primaryWhite};
        }
      }
      div.dropdown-content {
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        min-width: 180px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        z-index: 1;
        color: ${theme.textColor.primaryBlack};
        top: 130%;

        @media (min-width: 768px) {
          p {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            border-bottom: 1px solid ${theme.textColor.primaryGray};
            margin: 0;
            padding: 8px 16px;
            svg {
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }
            &:hover {
              background-color: ${theme.backgroundColor.primaryGray};
              transition: all 0.3s ease-in-out;
            }
          }
        }
        @media (max-width: 768px) {
          left: 0;
          background-color: ${theme.backgroundColor.primaryBlack};
          color: ${theme.textColor.primaryWhite};
          font-size: 12px;
          padding: 0px 16px;
          width: 100%;
          p {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;

            svg {
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }
          }
        }
      }
    }
    &:last-child {
      margin-left: auto;
    }
    a.title {
      font-size: 28px;
      font-weight: 200;
      margin: 0;
      color: ${theme.textColor.primaryWhite};
    }
    a {
      color: ${theme.textColor.secondaryGray};
      text-decoration: none;
      margin: 0 24px 0 0;
      &:hover {
        color: ${theme.textColor.primaryWhite};
      }
    }
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: ${theme.backgroundColor.primaryBlack};
    height: 100vh;
    padding: 5rem 0 0 0;
    top: 0;
    left: 0;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-100%)")};
    transition: transform 0.3s ease-in-out;
    z-index: 10000;
    width: 100%;

    div.header-sub-cont {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      padding: 0 !important;
    }
    ul {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      text-decoration: none;
      list-style-image: none;
      list-style-position: outside;
      list-style-type: none;
      line-height: 24px;
      margin: 0 !important;
      padding: 0 16px !important;
      width: 100%;

      li {
        margin-bottom: 30px;
        font-size: 18px;
        cursor: pointer;
      }
      a.title {
        font-size: 35px;
        font-weight: 300;
        padding-left: 16px;
      }
    }
  }
`;

export const StyledMobileHeader = styled.nav<{ open: boolean }>`
  display: flex;
  background-color: ${theme.backgroundColor.primaryBlack};
  color: ${theme.textColor.primaryWhite};
  font-size: 14px;
  font-weight: 500;
  padding: 16px;
  position: fixed;
  width: 100%;
  z-index: 100001;
  top: 0;
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    line-height: 24px;
    margin: 0;
    padding-left: 16px;
    padding-top: 2px;
    a.title {
      font-size: 28px;
      font-weight: 300;
      display: ${({ open }) => (open ? "none" : "block")};
    }
    a {
      color: ${theme.textColor.primaryWhite};
      text-decoration: none;
      margin: 0;
    }
  }
  @media (min-width: 768px) {
    display: none !important;
  }
`;

export const StyledBurger = styled.button<{ open?: boolean }>`
  // position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  background: transparent;
  z-index: 10000;

  &:focus {
    outline: none;
  }

  div {
    width: 2rem;
    height: 0.05rem;
    background-color: ${theme.textColor.primaryWhite};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? "0" : "1")};
      transform: ${({ open }) => (open ? "translateX(20px)" : "translateX(0)")};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
  @media (min-width: 768px) {
    display: none !important;
  }
`;
